module.exports = "/packs/images/homepage/activity/gymnastic_mobile~b7503adde8a0de2d7b7fe79fa32d6698.jpg";